import * as getters from "./getters";
import actions from "./actions";
import mutations from "./mutations";

export const getDefaultState = () => {
  return {
    cartIconIsShowingOrderInfo: false,
    fullScreenLoading: false,
    dialogs: {
      showForgotPasswordDialog: false,
      showAddChildrenToOrderDialog: false
    },
    config: {
      help: {},
      storefront: {}
    }
  };
};

// initial state
const state = getDefaultState();

export default {
  state,
  mutations,
  actions,
  getters
};
